import React from "react";
import { Box, Grid, Typography } from "@mui/material";

const StreamingGridView = ({ participants }) => {
  return (
    <div>
      <Grid container spacing={2}>
        {participants.map((participant) => (
          <Grid item xs={6} key={participant.id}>
            <Box border={1} borderRadius={2} p={1}>
              <Typography variant="body2" gutterBottom>
                {participant.isLocal ? "Local" : "Remote"} -{" "}
                {participant.userId}
              </Typography>
              {participant.videoStreams?.map((vs, idx) => (
                <Box key={idx}>
                  <video
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      marginBottom: "8px",
                    }}
                    autoPlay
                    playsInline
                    muted={participant.isLocal}
                    ref={(el) => {
                      if (el && vs.mediaStreamTrack) {
                        const stream = new MediaStream([vs.mediaStreamTrack]);
                        if (el.srcObject !== stream) {
                          el.srcObject = stream;
                        }
                      }
                    }}
                  />
                </Box>
              ))}
            </Box>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default StreamingGridView;
